<template>
  <div class="market-filter">
    <div
      class="market-filter-option"
      :class="{ active: current === item }"
      v-for="item in suite"
      :key="item"
      @click="change(item)">
      {{ $t('filters.markets.' + titles[item]) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    suite: Array
  },
  data () {
    return {
      current: 'a',
      titles: {
        a: 'all',
        m: 'main',
        h: 'handicaps',
        t: 'totals',
        o: 'other'
      }
    }
  },
  methods: {
    change (item) {
      this.current = item
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped>
.market-filter { display: flex; justify-content: center; margin-top: 5px; float: left; }
.market-filter-option { border-radius: 3px; cursor: pointer; height: 30px; line-height: 30px; padding: 0 15px; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.market-filter-option:hover { background: rgba(255, 255, 255, .05); }
.market-filter-option:not(:last-child) { margin-right: 10px; }
.active.market-filter-option { background: #8c9eff; box-shadow: inset 0 0 5px rgba(0, 0, 0, .5); }
</style>



// WEBPACK FOOTER //
// src/components/sports/eventview/MarketFilter.vue